import { APP_INITIALIZER, NgModule, isDevMode, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

// PrimeNG
import { MenubarModule } from 'primeng/menubar';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { DatePickerModule } from 'primeng/datepicker';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { SkeletonModule } from 'primeng/skeleton';
import { ChipModule } from 'primeng/chip';
import { DrawerModule } from 'primeng/drawer';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ToastModule } from 'primeng/toast';

// Components
import { NavigationBarComponent } from './components/navigation-bar/navigation-bar.component';
import { HeaderProfileComponent } from './components/header-profile/header-profile.component';
import { BreadcrumbComponent } from './components/breadcumb/breadcrumb.component';
import { ErrorDialogComponent } from './components/error-dialog/error-dialog.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { MenuComponent } from './components/sidebar-menu/menu.component';
import { CompanySelectComponent } from './components/company-select/company-select.component';
import { HeaderTitleComponent } from './components/header-title/header-title.component';
import { SplashscreenComponent } from './components/splashscreen/splashscreen.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { HubComponent } from './templates/hub/hub.component';
import { FooterComponent } from './components/footer/footer.component';
import { SimpleStatBoxComponent } from './components/charts/simple-stat-box/simple-stat-box.component';
import { RouteMapComponent } from './components/route-map/route-map.component';
import { LocationSearchComponent } from './components/location-search/location-search.component';
import { NoDataMessageComponent } from './components/no-data-message/no-data-message.component';
import { LocationCardComponent } from './components/location-card/location-card.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';

// Pipes
import { CarbonFootprintPipe } from './pipes/carbon-footprint.pipe';

// Standalone components
import { AppPanelComponent } from './components/app-panel/app-panel.component';
import { LanguageButtonComponent } from './components/language-button/language-button.component';

// Ekowitryna UI lib (standalone)
import {
  EkoLayoutHeaderComponent,
  EkoLayoutSidebarComponent,
  EkoLayoutFooterComponent,
  EkoDarkModeToggleComponent,
  EkoUserProfileComponent,
  EkoNavigationMenuComponent,
  EkoLanguageSelectorComponent,
  EkoGenericTableComponent
} from '@ekowitryna/ui';
import { GenericDialogFooter } from './components/generic-dialog-footer/generic-dialog-footer';

@NgModule({
  declarations: [
    NavigationBarComponent,
    HeaderProfileComponent,
    BreadcrumbComponent,
    ErrorDialogComponent,
    SidebarComponent,
    MenuComponent,
    CompanySelectComponent,
    HeaderTitleComponent,
    SplashscreenComponent,
    PageNotFoundComponent,
    HubComponent,
    FooterComponent,
    SimpleStatBoxComponent,
    RouteMapComponent,
    LocationSearchComponent,
    NoDataMessageComponent,
    LocationCardComponent,
    UnauthorizedComponent,
    CarbonFootprintPipe,
    GenericDialogFooter
  ],
  exports: [
    NavigationBarComponent,
    BreadcrumbComponent,
    ErrorDialogComponent,
    RouterModule,
    MenuComponent,
    CompanySelectComponent,
    HeaderTitleComponent,
    HeaderProfileComponent,
    SplashscreenComponent,
    PageNotFoundComponent,
    FooterComponent,
    SimpleStatBoxComponent,
    RouteMapComponent,
    LocationSearchComponent,
    NoDataMessageComponent,
    LocationCardComponent,
    UnauthorizedComponent,
    EkoGenericTableComponent,
    GenericDialogFooter,
    ButtonModule,
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CarbonFootprintPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,

    // PrimeNG
    MenubarModule,
    AvatarModule,
    ButtonModule,
    MenuModule,
    DatePickerModule,
    InputNumberModule,
    InputTextModule,
    SelectModule,
    ProgressSpinnerModule,
    DynamicDialogModule,
    SkeletonModule,
    DrawerModule,
    TooltipModule,
    ConfirmDialogModule,
    ChipModule,
    AutoCompleteModule,
    ToastModule,

    // Third-party
    FontAwesomeModule,
    TranslateModule,

    // Standalone components
    EkoGenericTableComponent,
    AppPanelComponent,
    LanguageButtonComponent,

    // UI lib standalone
    EkoLayoutHeaderComponent,
    EkoLayoutSidebarComponent,
    EkoLayoutFooterComponent,
    EkoDarkModeToggleComponent,
    EkoUserProfileComponent,
    EkoNavigationMenuComponent,
    EkoLanguageSelectorComponent
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi())
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {}
